fragment UserSessionFragment on UserSession {
    id
    user {
        id
        name
    }
    ipAddress
    loginTime
}
